import { useEffect, useRef } from 'react';
import { useLocation, useMatches } from 'react-router-dom';

export interface RouteHandle {
  title: string;
}

const APP_NAME = '깊콘';

function matchedTitle(matches: ReturnType<typeof useMatches>): string | undefined {
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const handle = matches[i]?.handle as RouteHandle | undefined;
    if (handle?.title) return handle.title;
  }
  return undefined;
}

export function usePageTitle() {
  const matches = useMatches();
  const { pathname } = useLocation();
  const title = matchedTitle(matches) ?? APP_NAME;
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = title === APP_NAME ? title : `${title} - ${APP_NAME}`;
  }, [title]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname은 본문에서 쓰지 않고 라우트 전환 시점을 트리거하는 용도로만 의존한다
  useEffect(() => {
    contentRef.current?.focus();
  }, [pathname]);

  return { title, contentRef };
}
